import { RequestConfig, RequestConfigType } from 'b2b-apps/shop/common/utils/api/RequestConfig';

class BarcodeSearch {
  public static fetch(barcode: string): RequestConfigType {
    return RequestConfig.get(
      `/catalog/search/barcode/${barcode}`,
    );
  }
}

export { BarcodeSearch };
